import React from "react";

import Icon from "assets/BGC_Page1_Icon.svg";
import BGCInfoPage from "./BGCInfoPage";

const PageOne: React.FC = () => (
  <BGCInfoPage
    icon={Icon}
    iconAlt="BGC Next App icon"
    heading="What is the BGC Next App?"
  >
    The BGC Next App houses certain cognitive assessments for research purposes.
    Our research collaborators from Northeastern University helped develop these
    tests. We want to understand how they relate to your BrainHealth Index.
  </BGCInfoPage>
);

export default PageOne;
